import { Box, Skeleton, TableCell, TableRow } from '@mui/material';

type SkeletonProps = {
  driversLength?: number;
};

export const SkeletonRow = ({ driversLength = 2 }: SkeletonProps) => {
  return (
    <TableRow
      data-testid="skeleton-row"
      sx={{
        '&:last-of-type td': {
          borderBottom: 'none',
        },
      }}
    >
      {/* ProductCell skeleton */}
      <TableCell
        sx={{
          bgcolor: 'neutral.lightest',
          padding: 0,
          borderRight: '1px solid',
          borderColor: 'neutral.lighter2',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            paddingX: 2,
            paddingY: 3,
            gap: 2,
            height: '100%',
          }}
        >
          {/* Product image skeleton */}
          <Skeleton variant="rounded" width={122} height={44} />

          {/* Product name skeleton */}
          <Skeleton variant="rounded" width={120} height={44} />

          {/* Star rating skeleton */}
          <Skeleton variant="rounded" width={80} height={20} />

          {/* CTA button skeleton */}
          <Skeleton variant="rounded" width="100%" height={70} />

          {/* Federally insured badge skeleton */}
          <Skeleton variant="rounded" width={100} height={14} />
        </Box>
      </TableCell>

      {/* DetailsCell skeleton */}
      <TableCell
        sx={{
          verticalAlign: 'top',
          borderColor: 'neutral.lighter2',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, height: '100%' }}>
          {Array.from({ length: driversLength }).map((_, index) => (
            <Skeleton key={index} variant="rounded" width="100%" height={75} />
          ))}
        </Box>
      </TableCell>
    </TableRow>
  );
};
